import {
  BundleTypes
} from '../../constants';

export class BundleBalance {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      airtimeBalance: this.fields.find((bundle) => bundle.name === BundleTypes.Airtime)?.totalUnrestrictedRemaining,
      dataBalance: this.fields.find((bundle) => bundle.name === BundleTypes.Data)?.totalUnrestrictedRemaining
    };
  }
}
